import type { ReactNode } from 'react';
import { Button, Flex, Text } from 'ui';

type P = {
  children: ReactNode;
  onSeeAll?: () => void;
  showSeeAll?: boolean;
  title: ReactNode;
};

const SearchResultsSection = ({ children, onSeeAll, showSeeAll, title }: P) => (
  <>
    <Flex align="flex-end" className="global-search-results-section" justify="space-between">
      <Text size="small" uppercase>
        {title}
      </Text>
      {showSeeAll ? (
        <Button onClick={onSeeAll} size="small" type="link-primary">
          See all
        </Button>
      ) : null}
    </Flex>
    {children}
  </>
);

export default SearchResultsSection;
